
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1359","height":"249","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1359 0H0v249h1359V0z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M33.73 6.65H20.75c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zm1303 0h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zm-1303 210H20.75c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zm1303 0h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zM74 249v-.45c0-8.13 2.28-14.72 5.1-14.72s5.1 6.59 5.1 14.72v.45H74zM74 0v.45c0 8.13 2.28 14.72 5.1 14.72S84.2 8.58 84.2.45V0H74zm1197 249v-.45c0-8.13 2.28-14.72 5.1-14.72s5.1 6.59 5.1 14.72v.45H1271zm0-249v.45c0 8.13 2.28 14.72 5.1 14.72s5.1-6.59 5.1-14.72V0H1271z","fill":"#fff"}})])
          )
        }
      }
    